import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isAuthenticated } from "routes/auth";

/**
 * Guard for authenticated-only routes. Currently checks an `auth_token`
 * in `localStorage`; replace `isAuthenticated` with your real auth
 * source (context, redux, react-query, etc.) when available.
 */
export default function ProtectedRoute() {
  const hasSession = isAuthenticated();
  const location = useLocation();

  if (!hasSession) {
    return <Navigate to="/sign-in" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
